import * as Sentry from '@sentry/react';

const DSN = import.meta.env.VITE_SENTRY_DSN;
const IS_PROD = import.meta.env.PROD;

// WHY: session-scoped guard so the missing-DSN warning fires once per browser session,
// not on every page load.
const DSN_WARNING_SHOWN_KEY = 'BH:sentry_dsn_warned';

/**
 * Initialize Sentry for error tracking.
 * Disabled in development, enabled in staging/production via DSN presence.
 */
export function initSentry() {
  if (!DSN) {
    if (IS_PROD && !sessionStorage.getItem(DSN_WARNING_SHOWN_KEY)) {
      sessionStorage.setItem(DSN_WARNING_SHOWN_KEY, 'true');
      console.warn('Sentry DSN is missing in production environment.');
    }
    return;
  }

  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE,
    enabled: IS_PROD
  });
}
